import { render } from "./DiagnosisScreenManageList.vue?vue&type=template&id=33a42606&scoped=true"
import script from "./DiagnosisScreenManageList.vue?vue&type=script&lang=js"
export * from "./DiagnosisScreenManageList.vue?vue&type=script&lang=js"

import "./DiagnosisScreenManageList.vue?vue&type=style&index=0&id=33a42606&scoped=true&lang=css"
import "./DiagnosisScreenManageList.vue?vue&type=style&index=1&id=33a42606&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a42606"]])

export default __exports__